import { orderTotalDisplayStyles as styles } from "@insite/content-library/Components/OrderTotalDisplay";
import getColor from "@insite/mobius/utilities/getColor";
import { typography } from "@solveindustrial/Utilities/styleguide";
import { buttonCommon } from "@solveindustrial/Utilities/styleguide/button";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.container = {
    ...styles.container,

    css: css`
        ${styles.container?.css}
        padding: 24px;
        background-color: ${getColor(colorStrings.commonGlobalWhite)};

        border-radius: 4px;
        border: solid 1px ${getColor(colorStrings.commonBorder)};

        ${mediaQueriesBP.minMD} {
            padding: 40px;
        }
    `,
};

styles.subtotalLabel = {
    ...styles.subtotalLabel,
    ...typography.bodyBig,
    css: css`
        ${styles.subtotalLabel?.css};
        ${typography.bodyBig.css}
    `,
    mergeCss: true,
};

styles.subtotalValue = {
    ...styles.subtotalValue,
    ...typography.bodyBig,
    css: css`
        ${styles.subtotalValue?.css};
        ${typography.bodyBig.css}
    `,
    mergeCss: true,
};

styles.discountsLabel = {
    ...styles.discountsLabel,
    ...typography.bodyBig,
    css: css`
        ${styles.discountsLabel?.css};
        ${typography.bodyBig.css}
    `,
    mergeCss: true,
};

styles.discountsValue = {
    ...styles.discountsValue,
    ...typography.bodyBig,
    css: css`
        ${styles.discountsValue?.css};
        ${typography.bodyBig.css}
    `,
    mergeCss: true,
};

styles.shippingAndHandlingLabel = {
    ...styles.shippingAndHandlingLabel,
    ...typography.bodyBig,
    css: css`
        ${styles.shippingAndHandlingLabel?.css};
        ${typography.bodyBig.css}
    `,
    mergeCss: true,
};

styles.shippingAndHandlingValue = {
    ...styles.shippingAndHandlingValue,
    ...typography.bodyBig,
    css: css`
        ${styles.shippingAndHandlingValue?.css};
        ${typography.bodyBig.css}
    `,
    mergeCss: true,
};

styles.otherChargesLabel = {
    ...styles.otherChargesLabel,
    ...typography.bodyBig,
    css: css`
        ${styles.otherChargesLabel?.css};
        ${typography.bodyBig.css}
    `,
    mergeCss: true,
};

styles.otherChargesValue = {
    ...styles.otherChargesValue,
    ...typography.bodyBig,
    css: css`
        ${styles.otherChargesValue?.css};
        ${typography.bodyBig.css}
    `,
    mergeCss: true,
};

styles.taxLabel = {
    ...styles.taxLabel,
    ...typography.bodyBig,
    css: css`
        ${styles.taxLabel?.css};
        ${typography.bodyBig.css}
    `,
    mergeCss: true,
};

styles.taxValue = {
    ...styles.taxValue,
    ...typography.bodyBig,
    css: css`
        ${styles.taxValue?.css};
        ${typography.bodyBig.css}
    `,
    mergeCss: true,
};

styles.totalLabel = {
    ...styles.totalLabel,
    ...typography.bodyBig,
    weight: 700,
    css: css`
        ${styles.totalLabel?.css};
        ${typography.bodyBig.css}
    `,
    mergeCss: true,
};

styles.totalValue = {
    ...styles.totalValue,
    ...typography.bodyBig,
    weight: 700,
    css: css`
        ${styles.totalValue?.css};
        ${typography.bodyBig.css}
    `,
    mergeCss: true,
};
